import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import RatingBadgeContainer from './RatingBadgeContainer';
import { scrollToSectionAction } from '../../store/actions/view';
import { COMPONENT_ID } from '../../constants';
import { getHotelRating } from '../../store/hotel';

const mapStateToProps = (state) => ({
  value: getHotelRating(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch, { isMobile }) => ({
  onClick: () =>
    dispatch(
      isMobile
        ? scrollToSectionAction(COMPONENT_ID.TRUST_YOU)
        : scrollToSectionAction(COMPONENT_ID.HOTEL_FACTS),
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RatingBadgeContainer);
